import { render, staticRenderFns } from "./CreateExercise.vue?vue&type=template&id=7c604b9e"
import script from "./CreateExercise.vue?vue&type=script&lang=js"
export * from "./CreateExercise.vue?vue&type=script&lang=js"
import style0 from "./CreateExercise.vue?vue&type=style&index=0&id=7c604b9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports